import React, { useState, useRef } from 'react';
import { Modal, Col, Row, Button, Skeleton, notification  } from 'antd';
import './paraphrase-ai-modal.css';
import { getPraphrasedSentence } from  './services/paraphraser-apis'
import { trackEvent } from "../utils/util-functions";

const ParaphraseAi = ({ visible, onClose, handleParaphraseChange,questionDescription }) => {
    // const [synonymRange, setSynonymRange] = useState(3);
    // const [paraphraseMode, setParaphraseMode] = useState('Standard');
    const [ paraphrasedContent, setParaphrasedContent] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    // const paraphraseModes = [
    //     { value: 'Fluency', label: 'Fluency' },
    //     { value: 'Natural', label: 'Natural' },
    //     { value: 'Academic', label: 'Academic' },
    //     { value: 'Standard', label: 'Standard' },
    //     { value: 'Simple', label: 'Simple' },
    //     { value: 'Creative', label: 'Creative' },
    //     { value: 'Expand', label: 'Expand' },
    //     { value: 'Shorten', label: 'Shorten' }
    // ];

    // const handleChange = (value) => {
    //     setParaphraseMode(value);
    // };

    // const onChange = (value) => {
    //     setSynonymRange(value);
    // };

    const paraphraseWithAi = async () => {
        const checks = [
            // { condition: !synonymRange, message: 'Synonym range is not selected' },
            // { condition: !paraphraseMode, message: 'Paraphrasing mode is not selected' },
            { condition: !questionDescription, message: 'A sentence is needed for Paraphrasing.' },
        ];
    
        for (const check of checks) {
            if (check.condition) {
                notification.error({
                    message: 'Error',
                    description: check.message,
                });
                return;
            }
        }
       
        // Use removePTags to clean the description
        // const cleanedDescription = stripHtmlTags(questionDescription);
        const reqObj = {
            // "synonymRange": synonymRange,
            // "paraphraseMode": paraphraseMode,
            "sentence": stripHtmlTags(questionDescription)
        };
        
        setIsLoading(true);

        trackEvent('paraphrase_ai_button_clicked', {
            from: 'csLab'
        });

        const response = await getPraphrasedSentence(reqObj)
        setIsLoading(false)
        if (response.data.statusCode === 200) {
            setParaphrasedContent(response.data.response.sentence);
        } else {
            notification.error({
                message: 'Error',
                description: 'An error occurred, Please try again',
            });
        }
        
    };

    
    const contentRef = useRef(null);

    const handleInsert = () => {
        const plainTextContent = stripHtmlTags(paraphrasedContent);
        handleParaphraseChange(plainTextContent);
        setParaphrasedContent("")
        onClose();
    };
    
    const stripHtmlTags = (input) => {
        const div = document.createElement('div');
        div.innerHTML = input;
        return div.textContent || div.innerText || '';
    };
    

    return (
        <Modal
            className='paraphase-modal'
            title="Paraphase your input"
            centered
            open={visible}
            okText="Paraphrase"
            onOk={onClose}
            onCancel={onClose}
            closable={false}
            footer={null}
        >
            <Col span={24}>
                {/* <Row justify="space-between">
                    <Col span={14} className="mx-2">
                        <Row style={{backgroundColor:'#FEF8F8', borderRadius:'10px'}} align="middle">
                            <Col>
                                <label style={{fontWeight:'500'}} className="mx-2">Synonyms:</label>
                            </Col>
                            <Col span={8} flex="auto">
                                <Slider
                                    max={10}
                                    value={synonymRange}
                                    onChange={onChange}
                                    handleSize={3}
                                    trackStyle={{ backgroundColor: '#E96358' }}
                                />
                            </Col>
                        </Row>
                    </Col>

                    <Col span={8}>
                        <Space wrap>
                            <Select
                                value={paraphraseMode}
                                style={{ width: 120 }}
                                onChange={handleChange}
                                options={paraphraseModes}
                                optionSelectedBg = {'#E96358'}
                            />
                        </Space>
                    </Col>
                </Row> */}
                <div>{stripHtmlTags(questionDescription)}</div>
            </Col>
            <hr className='breaker-line' />
            {paraphrasedContent && !isLoading && (
                <div ref={contentRef} dangerouslySetInnerHTML={{ __html: paraphrasedContent }} />
            )}
            {isLoading &&
                <Skeleton active />
            }


            <Row justify="end">
                {paraphrasedContent && <Button style={{ backgroundColor: '#FFECD2', color: 'black' }} className='mx-2' type="primary" onClick={handleInsert}>Insert Changes</Button>

                }

                <Button className="mx-2" type="primary" onClick={paraphraseWithAi}>Paraphrase</Button>

            </Row>
        </Modal>
    );
};

export default ParaphraseAi;
